import { cn } from "@/lib/utils";

import { useConfigurationContext } from "../root/ConfigurationContext";

export const Status = ({
  status,
  className,
  labeled = false,
}: {
  status: string;
  className?: string;
  labeled?: boolean;
}) => {
  const { noteStatuses } = useConfigurationContext();
  if (!status || !noteStatuses) return null;
  const statusObject = noteStatuses.find((s: any) => s.value === status);

  if (!statusObject) return null;
  if (!labeled) {
    return (
      <span
        title={statusObject.label}
        className={cn("inline-block size-2.5 rounded-full", className)}
        style={{ backgroundColor: statusObject.color }}
      />
    );
  }
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full bg-muted px-2 py-0.5 text-xs font-medium whitespace-nowrap",
        className,
      )}
    >
      <span
        className="size-2 rounded-full"
        style={{ backgroundColor: statusObject.color }}
      />
      {statusObject.label}
    </span>
  );
};
